import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import YouTube from 'react-youtube';
import Helmet from 'react-helmet';
import Markdown from 'react-remarkable';
import { jsx, css } from '@emotion/core';

import ListSinglePost from '../List/ListSinglePost';
import ShareButtons from '../../../shared/ShareButtons/ShareButtons';

import { loadPost } from '../../../../redux/modules/singlePost';
import { loadSidebarPosts } from '../../../../redux/modules/posts';
import connectDataFetchers from '../../../shared/lib/connectDataFetchers.js';

import './SinglePost.scss';
import IubendaCookieSolution from '../../../../utils/iubenda';
import A from '../../../shared/Anchor/Anchor';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher.js';
import { cleanImage } from '../../../../utils/images.js';

class SinglePost extends Component {
  state = { isConsentGiven: false };

  async componentDidMount() {
    const iubenda = new IubendaCookieSolution(
      this.props.hasIubendaCookieSolution
    );
    const isConsentGiven = await iubenda.isConsentGiven();
    this.setState({
      isConsentGiven,
    });
  }

  renderNewlineText(text) {
    return text.split('\n').map((item, key) => {
      return (
        <span key={key}>
          {item}
          <br />
        </span>
      );
    });
  }

  renderSectionByType = section => {
    const { post } = this.props;
    const type = section.type.toLowerCase();

    switch (type) {
      case 'text':
        return (
          <div>
            <Markdown source={section.text} />
          </div>
        );
      case 'image_text':
        return (
          <div className="row">
            <div className="col-sm-4">
              {!!section.imageLink ? (
                <A
                  href={section.imageLink}
                  target={'_blank'}
                  aria-label="Apri il link dell'immagine"
                >
                  <ImageDispatcher
                    alt={`Immagine ${post.title}`}
                    src={section.imageUrl}
                    className="img-fluid"
                  />
                </A>
              ) : (
                <ImageDispatcher
                  alt={`Immagine ${post.title}`}
                  src={section.imageUrl}
                  className="img-fluid"
                />
              )}
            </div>
            <div className="col-sm-8">
              <Markdown source={section.text} />
            </div>
          </div>
        );
      case 'text_image':
        return (
          <div className="row">
            <div className="col-sm-8">
              <Markdown source={section.text} />
            </div>
            <div className="col-sm-4">
              {!!section.imageLink ? (
                <A
                  href={section.imageLink}
                  target={'_blank'}
                  aria-label="Apri il link dell'immagine"
                >
                  <ImageDispatcher
                    alt={`Immagine ${post.title}`}
                    src={section.imageUrl}
                    className="img-fluid"
                  />
                </A>
              ) : (
                <ImageDispatcher
                  alt={`Immagine ${post.title}`}
                  src={section.imageUrl}
                  className="img-fluid"
                />
              )}
            </div>
          </div>
        );
      case 'image':
        return (
          <div>
            {!!section.imageLink ? (
              <A
                href={section.imageLink}
                target={'_blank'}
                aria-label="Apri il link dell'immagine"
              >
                <ImageDispatcher
                  alt={`Immagine ${post.title}`}
                  src={section.imageUrl}
                  className="img-fluid"
                />
              </A>
            ) : (
              <ImageDispatcher
                alt={`Immagine ${post.title}`}
                src={section.imageUrl}
                className="img-fluid"
              />
            )}
          </div>
        );
      case 'video':
        return this.state.isConsentGiven ? (
          <div className="embed-responsive embed-responsive-16by9">
            <YouTube
              videoId={section.videoUrl}
              className="embed-responsive-item"
            />
          </div>
        ) : null;
      default:
        return null;
    }
  };

  renderSections = sections => {
    const sectionStyle = css`
      a {
        color: ${this.props.primaryColor};
        font-weight: bold;
      }
    `;

    return (
      !!sections &&
      sections.map(section => {
        return (
          <section className="post-section" key={section.id} css={sectionStyle}>
            {this.renderSectionByType(section)}
          </section>
        );
      })
    );
  };

  renderLatestPosts = (posts, uiVariantButton) => {
    return posts.map(post => {
      return (
        <div className="col-md-4" key={post.id}>
          <ListSinglePost post={post} uiVariantButton={uiVariantButton} />
        </div>
      );
    });
  };

  render() {
    const {
      post,
      latestPosts,
      siteName,
      primaryColor,
      facebookAppId,
      uiVariantButton,
    } = this.props;

    const latestThreePosts = latestPosts
      .filter(p => p.id !== post.id)
      .slice(0, 3);

    const postStyle = css`
      &.variant-1 {
        .post-wrapper img {
          border-radius: 12px;

          &.blog-image {
            border-radius: 12px;
          }
        }
      }

      &.variant-2 {
      }

      &.variant-3 {
        .post-wrapper img {
          border-radius: 6px;

          &.blog-image {
            border-radius: 6px;
          }
        }
      }
    `;

    if (!post.title) {
      return <Helmet meta={[{ name: 'robots', content: 'noindex' }]} />;
    }
    return (
      <div className={`single-post variant-${uiVariantButton}`} css={postStyle}>
        <Helmet
          title={`${post.title}`}
          meta={[
            { name: 'description', content: `${siteName} - ${post.title}` },
            {
              name: 'keywords',
              content: `${siteName}, blog farmacia, ${post.title}`,
            },
            { property: 'og:title', content: `${siteName} - ${post.title}` },
            { property: 'og:type', content: 'website' },
            {
              property: 'og:description',
              content: `${siteName} - ${post.title}`,
            },
            {
              property: 'og:image',
              content: cleanImage(post.featuredImageUrl),
            },
          ]}
        />

        <div className="container">
          <div className="post-wrapper">
            <div className="date">
              {moment(post.date).format('DD MMMM YYYY')}
            </div>
            <h2
              style={{
                textAlign: 'center',
              }}
            >
              {post.title}
            </h2>
            {!!post.featuredImageUrl && (
              <ImageDispatcher
                alt={post.title}
                src={post.featuredImageUrl}
                className="img-fluid blog-image"
              />
            )}
            {this.renderSections(post.sections)}
            <div className="share">
              <div className="text">Condividi su</div>
              <div className="icons">
                <ShareButtons
                  primaryColor={primaryColor}
                  twitterMessage="Articolo interessante:"
                  facebookAppId={facebookAppId}
                />
              </div>
            </div>
          </div>

          <hr />

          <h2 className="latest-title">Ultimi articoli</h2>
          <div className="row">
            {this.renderLatestPosts(latestThreePosts, uiVariantButton)}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    post: state.singlePost.data,
    latestPosts: state.posts.data.latest,
    siteName: state.store.data.datiFarmacia.siteName,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    facebookAppId: state.store.data.integrazioni.facebook.appId,
    uiVariantButton: state.store.data.uiVariants.buttons,
    hasIubendaCookieSolution:
      state.store.data.features.hasIubendaCookieSolution,
  };
}

export default connect(mapStateToProps)(
  connectDataFetchers(SinglePost, [loadPost, loadSidebarPosts])
);
